<template>
  <v-app>
    <v-main class="tw-bg-gray-50">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="7" lg="6">
            <v-card class="elevation-2 tw-rounded-2xl pa-6 pa-md-10 tw-text-center">
              <v-icon color="warning" size="88" class="tw-mb-4">
                mdi-cloud-off-outline
              </v-icon>

              <h1 class="tw-text-2xl tw-font-bold tw-mb-4">
                ไม่สามารถเชื่อมต่อระบบได้ในขณะนี้
              </h1>

              <p class="tw-text-gray-700 tw-mb-3 tw-leading-relaxed">
                ขออภัยในความไม่สะดวก ขณะนี้ระบบไม่สามารถเชื่อมต่อกับฐานข้อมูลได้ชั่วคราว
                ซึ่งอาจเกิดจากการเชื่อมต่ออินเทอร์เน็ตของท่าน
                หรือการปรับปรุงระบบของผู้ให้บริการ
              </p>

              <p class="tw-text-gray-700 tw-mb-6 tw-leading-relaxed">
                ระบบจะพยายามเชื่อมต่อใหม่โดยอัตโนมัติ
                และจะนำท่านกลับเข้าสู่หน้าเดิมทันทีเมื่อเชื่อมต่อสำเร็จ
                กรุณารอสักครู่
              </p>

              <div
                class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-gray-500 tw-mb-6"
                role="status"
                aria-live="polite"
              >
                <v-progress-circular
                  indeterminate
                  size="18"
                  width="2"
                  color="light-green"
                ></v-progress-circular>
                <span>กำลังตรวจสอบการเชื่อมต่อโดยอัตโนมัติ…</span>
              </div>

              <v-alert
                v-if="retryFailed"
                type="error"
                text
                dense
                class="tw-text-left tw-mb-6"
              >
                ยังไม่สามารถเชื่อมต่อได้ กรุณาลองอีกครั้งในอีกสักครู่
              </v-alert>

              <v-btn
                color="primary"
                large
                class="tw-font-bold"
                :loading="retrying"
                @click="retry"
              >
                <v-icon left>mdi-refresh</v-icon>
                ลองเชื่อมต่อใหม่อีกครั้ง
              </v-btn>

              <p class="tw-text-sm tw-text-gray-500 tw-mt-8 tw-mb-0">
                หากปัญหายังคงอยู่ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของท่าน
                หรือติดต่อทีมงานผู้ดูแลระบบ
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { retryConnection } from '@/libs/firestoreHealth'

export default {
  name: 'ConnectionError',
  data () {
    return {
      retrying: false,
      retryFailed: false
    }
  },
  methods: {
    async retry () {
      this.retrying = true
      this.retryFailed = false
      // `retryConnection()` probes the server and, on success, dispatches
      // `connectionHealth/markBackendHealthy` to clear the banner state.
      // Catastrophic page no longer auto-routes back — the user explicitly
      // navigates by clicking the system menu or refreshing.
      const ok = await retryConnection()
      if (!ok) {
        this.retryFailed = true
      } else {
        // Connection restored — go home so the user isn't stuck on the
        // error page. We don't have lostFromPath in passive mode.
        this.$router.push('/').catch(() => {})
      }
      this.retrying = false
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
}
</style>
